@if (showYearSelector) {
  <div class="year-selection-container">
    <p class="enrollmentYear">
      <span>{{ selectYearHeading || 'Enrollment Year' }}
        <span aria-hidden="false" class="material-symbols-outlined info-icon" aria-label="checkbox tooltip"
          matTooltip="{{tooltipText || 'Select the year your coverage should begin'}}">info
        </span>
      </span>
      @if (selectYearPrompt) {
        <br/>
        <span>{{ selectYearPrompt }}</span>
      }
    </p>
    <div class="year-content hmhs-horizontal-padding-1-rem zipCounty">
      <mat-button-toggle-group [(ngModel)]="yearSelected" (change)="saveYearSelectionToState( yearSelected )" [hideSingleSelectionIndicator]="true">
        <mat-button-toggle value="{{yearA}}" aria-label="Show {{yearA}} Plans">
          <span class="material-symbols-outlined done currentYear">done</span> {{yearA}}
        </mat-button-toggle>
        <mat-button-toggle value="{{yearB}}" aria-label="Show {{yearB}} Plans">
          <span class="material-symbols-outlined done nextYear">done</span> {{yearB}}
        </mat-button-toggle>
      </mat-button-toggle-group>
    </div>
  </div>
}